import { Box } from '@mui/material';
import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RoundedButton from '@components/RoundedButton';

import { ADMIN_NEW_ACCOUNT } from '@constants/routes';

const messages = defineMessages({
  newPatient: {
    id: 'organization.patient.create',
    defaultMessage: 'Add New Patient',
  },
  reportFeedback: {
    id: 'feedback.report',
    defaultMessage: 'Report Feedback',
  },
});

function ActionButtons() {
  const { formatMessage } = useIntl();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
      <RoundedButton
        autoSize
        iconName="add"
        onClick={() => navigate(ADMIN_NEW_ACCOUNT)}
        textTransform="capitalize"
      >
        {formatMessage(messages.newPatient)}
      </RoundedButton>
    </Box>
  );
}

export default ActionButtons;
